module.exports = __webpack_public_path__ + "static/media/EVZ.F_BIG.b0ec2925.svg";